// src/config-client.js
const DEFAULT_API_BASE = 'https://vc9kugsjnd.execute-api.eu-north-1.amazonaws.com/dev';

export async function fetchConfig({ venue, apiBase = DEFAULT_API_BASE }) {
  try {
    const res = await fetch(`${apiBase}/chat/config?venue=${encodeURIComponent(venue)}`, {
      method: 'GET',
      credentials: 'omit',
    });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}
